import * as io from 'socket.io-client'

const SOCKET_ENDPOINT = 'wss://io.plan.com'

const __socket = io.connect(SOCKET_ENDPOINT, {
  transports: ['websocket'],
  upgrade: false,
  secure: true,
})

export const dev_socket = {}

const inspector = {
  connected: !!localStorage.getItem('connected_to_inspector'),
  ready: false,
  event_name: 'v4-inspector',
  from_event_name: 'from-v4-inspector',
  tab_id: null,
  send: data => {
    if (inspector.connected) {
      if (inspector.ready) {
        const event = new CustomEvent(inspector.event_name, data)
        document.dispatchEvent(event)
      } else {
        inspector.pre_ready_stack.push(data)
      }
    }
  },
  handle_message: params => {
    // console.log(params.detail)
    if (params.detail.action === 'connect') {
      inspector.tab_id = params.detail.tabId
      inspector.connected = true
      localStorage.setItem('connected_to_inspector', '1') // persists after a refresh
    } else if (params.detail.action === 'ready') {
      console.log('v4-Inspector ready')
      inspector.ready = true
      inspector.pre_ready_stack.map(data => inspector.send(data))
    } else if (params.detail.action === 'set_initial_store') {
      inspector.set_initial_store()
    } else if (params.detail.action === 'reset_initial_store') {
      localStorage.removeItem('store')
      localStorage.removeItem('proxy_cache')
      inspector.send({ detail: { action: 'config', initial_store_set: false } })
    }
  },
  send_action: action => {
    inspector.send({ detail: action })
  },
  save_current_store: name => {
    // const suffix = (name && '_' + name) || ''
    // localStorage.setItem('store' + suffix, JSON.stringify(store.getState()))
    // localStorage.setItem('proxy_cache' + suffix, JSON.stringify(proxy_cache))
  },
  set_initial_store: (name?) => {
    inspector.save_current_store(name)
    inspector.send({ detail: { action: 'config', initial_store_set: true } })
  },
  init: () => {
    document &&
      document.removeEventListener(
        inspector.from_event_name,
        inspector.handle_message,
      )
    document &&
      document.addEventListener(
        inspector.from_event_name,
        inspector.handle_message,
      )
  },
  pre_ready_stack: [
    { detail: { action: 'link-established', display: 'none' } },
    {
      detail: {
        action: 'config',
        display: 'none',
        config: {
          websockets: true,
          proxy: true,
          app: true,
        },
        // app_config: config,
        // initial_store_set: storage.has('store'),
      },
    },
  ],
}

export const socketEventHandler = {
  emit: data => {
    inspector.send({
      detail: {
        id: data.id,
        url: data.cmd,
        host: SOCKET_ENDPOINT,
        params: { data: data.params, url: data.cmd },
      },
    })
  },
  received: (data, response, timing) => {
    inspector.send({
      detail: {
        id: data.id,
        params: { data: data.params, url: data.cmd },
        response,
        timing,
      },
    })
  },
  handle_auth_verified: () => null,
  handle_connect: () => {
    inspector.send_action({ id: '0', action: 'connect' })
  },
  handle_disconnect: () => {
    inspector.send_action({ id: 'x', action: 'disconnect' })
  },
  init: () => {
    inspector.init()
  },
}

// const LOG_PERF = config.MODE === 'DEV'
const LOG_PERF = process.env.NODE_ENV !== 'PROD'
const perf_measure = (label, start, stop) => {
  performance.mark(stop)
  performance.measure('↔️️ ' + label, start, stop)
}

const NOT_AUTHORIZED_HTTP_STATUS = [401, 403]

const socket = {
  req_id: 0,
  token: localStorage.getItem('token'),
  authorized: null,
  first_call_timestamp: null,
  emit: settings => {
    return new Promise((resolve, reject) => {
      const req_id = ++socket.req_id
      __socket && socketEventHandler.emit({ ...settings, id: req_id })
      let timing = +new Date()
      const { method, cmd, params } = settings
      !socket.first_call_timestamp &&
        (socket.first_call_timestamp = performance.now())
      LOG_PERF && performance.mark('emit' + req_id)
      __socket &&
        __socket.emit(method, { ...params, id: req_id }, response => {
          // console.log(response)
          timing = +new Date() - timing
          socketEventHandler.received(
            { ...settings, id: req_id, timing },
            response,
            timing,
          )
          if (!response.status || response.status !== 200) {
            LOG_PERF &&
              perf_measure(
                cmd || 'Unknown websocket call',
                'emit' + req_id,
                'response' + req_id,
              )
            reject({ error: `${method} ${cmd} failed`, response })
            if (
              socket.authorized === null &&
              ~NOT_AUTHORIZED_HTTP_STATUS.indexOf(response.status)
            ) {
              socket.authorized = false
              window.dispatchEvent(
                new CustomEvent('authorized', {
                  detail: { status: 'rejected' },
                }),
              )
              // console.log('not authorized')
            }
          } else {
            LOG_PERF &&
              perf_measure(
                cmd || 'Unknown websocket call',
                'emit' + req_id,
                'response' + req_id,
              )
            resolve(response)
            if (socket.authorized === null) {
              socket.authorized = false
              window.dispatchEvent(
                new CustomEvent('authorized', {
                  detail: { status: 'authorized' },
                }),
              )
              // console.log('authorized', settings)
            }
          }
        })
    })
  },
  get: (data, params) => {
    if (typeof data === 'string') {
      data = { cmd: data }
      params && (data.params = params)
    }
    return new Promise((resolve, reject) => {
      const { cmd, params } = data
      if (!socket.token) {
        console.error('socket.get called while token is not set:', cmd, params)
      } else {
        socket
          .emit({
            method: 'GET single',
            cmd,
            params: { url: cmd, data: { token: socket.token, ...params } },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      }
    })
  },
  getPublic: (data, params) => {
    if (typeof data === 'string') {
      data = { cmd: data }
      params && (data.params = params)
    }
    return new Promise((resolve, reject) => {
      const { cmd, params } = data
      socket
        .emit({
          method: 'GET single',
          cmd,
          params: { url: cmd, data: { ...params } },
        })
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
  post: (data, params) => {
    if (typeof data === 'string') {
      data = { cmd: data }
      params && (data.params = params)
    }
    return new Promise((resolve, reject) => {
      const { cmd, params } = data
      if (!socket.token) {
        console.error('socket.post called while token is not set:', cmd, params)
      } else {
        socket
          .emit({
            method: 'POST single',
            cmd,
            params: { url: cmd, data: { token: socket.token, ...params } },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      }
    })
  },
  auth: data => {
    return new Promise((resolve, reject) => {
      socket
        .emit({
          method: 'AUTH sign_in',
          cmd: 'AUTH sign_in',
          params: data.params,
        })
        .then(response => {
          response &&
            response.user_data &&
            socket.store_token(response.user_data.token)
          socketEventHandler.handle_auth_verified()
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  verify: (token?) => {
    token = token || socket.token
    return new Promise((resolve, reject) => {
      socket
        .emit({ method: 'AUTH verify', cmd: 'AUTH verify', params: { token } })
        .then(response => {
          socketEventHandler.handle_auth_verified()
          resolve(response)
        })
        .catch(error => {
          console.log('rejecting auth')
          reject(error)
        })
    })
  },
  store_token: token => {
    socket.token = token
    localStorage.setItem('token', socket.token)
  },
  send_action: action => {
    /* JSON.stringify(action) */
  },
}
// const style = 'background-color: rgba(71, 192, 113, 1); color: white; border-radius: 7px'
// __socket &&
//     __socket.on('connect', (data) => {
//         console.log('%c  ', style, 'Socket event: Socket connected to ' + socket_endpoint)
//         socketEventHandler.handle_connect()
//     })
// __socket &&
//     __socket.on('welcome', (data) => {
//         console.log('%c  ', style, 'Socket event: Welcome from Proxy', data)
//     })
// __socket &&
//     __socket.on('disconnect', () => {
//         console.log('%c  ', style, 'Disconnected from Proxy')
//         socketEventHandler.handle_disconnect()
//     })
// __socket && __socket.on('hash', () => null)
// __socket && __socket.on('go_to_hash_from_device', () => null)
// __socket && __socket.on('device_list', () => null)
// __socket && __socket.on('device_online', () => null)
// __socket && __socket.on('device_offline', () => null)

export default socket
